<script setup>
import { computed, watch, ref } from "vue";
import { useRoute } from "vue-router";
import Router from "@/router/index.js";
import { useBreadcrumbStore } from "@/stores/BreadcrumbStore";
import { useCalendarStore } from "@/stores/CalendarStore";
import { useTicketStore } from "@/stores/TicketStore";

const breadcrumbStore = useBreadcrumbStore();
const calendarStore = useCalendarStore();
const ticketStore = useTicketStore();

var breadcrumbs = ref([]);
const route = useRoute();
watch(
  () => route.meta.breadcrumbs,
  (crumbs) => {
    breadcrumbs.value = crumbs;
  },
  { immediate: true },
);

const policyCrumbs = computed(() => {
  const path = breadcrumbStore.getPolicyPath || [];
  const items = [{ name: "Policies", link: "/policies" }];
  path.forEach((node) => {
    if (!node?.id) {
      return;
    }
    items.push({ name: node.name, link: `/policies?folder=${node.id}` });
  });
  return items;
});

const policyViewCrumbs = computed(() => {
  const path = breadcrumbStore.getPolicyPath || [];
  const items = [{ name: "Policy", link: "/policies" }];
  path.forEach((node, index) => {
    if (!node?.name) {
      return;
    }
    const isLast = index === path.length - 1;
    if (isLast) {
      items.push({ name: node.name });
      return;
    }
    if (!node.id) {
      items.push({ name: node.name });
      return;
    }
    items.push({ name: node.name, link: `/policies?folder=${node.id}` });
  });
  if (!path.length && route.name === "policy-new") {
    items.push({ name: "New" });
  }
  return items;
});

const displayCrumbs = computed(() => {
  if (route.name === "policies") {
    return policyCrumbs.value;
  }
  if (route.name === "policy-editor" || route.name === "policy-new") {
    return policyViewCrumbs.value;
  }
  return breadcrumbs.value || [];
});
const view = (link) => {
  const isTicketsLink = link === "/tickets";
  const alreadyOnTickets = route.path === "/tickets";

  if (isTicketsLink && alreadyOnTickets) {
    ticketStore.requestListRefresh();
    ticketStore.fetchUnansweredCount({ force: true });
    return;
  }

  Router.push(link);

  // Temporary ugliness until ListStore is rewritten
  if (link == "/calendar") {
    calendarStore.updateDateFromRoute(route);
  }
};
</script>
<template>
  <div class="flex flex-wrap w-full">
    <span v-for="(crumb, index) in displayCrumbs" :key="crumb.link || crumb.name || index" class="cursor-pointer">
      <span v-if="crumb.link !== undefined" @click.prevent="view(crumb.link)"
        class="p-3 text-accent whitespace-normal hover:cursor">
        {{ crumb.name }}
      </span>
      <span v-else-if="crumb.name !== undefined" class="p-3 text-accent whitespace-normal hover:cursor">
        {{ crumb.name }}
      </span>
      <span v-else-if="crumb.value !== undefined && crumb.value === true" class="p-3 text-accent whitespace-normal">
        {{ breadcrumbStore.getValue }}
      </span>
      <span v-if="index < displayCrumbs.length - 1" class="text-accent px-1">></span>
    </span>
  </div>
</template>
